module.exports = __webpack_public_path__ + "static/media/logo_w.7515694f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_w.png
// module id = 14
// module chunks = 0